/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelQualifierCode.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/qualifier-code";

export class AutogenModelQualifierCode<RowType extends ModelRow> extends Endpoint<RowType, RowQualifierCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowQualifierCode extends ModelRow<RowQualifierCodeFields> {
	constructor(values?: Partial<RowQualifierCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowQualifierCodeFields {
	element_id: string;
	is_edi_customer: boolean;
	partner_id: string;
	version: string;
	customer_id: string;
}

